export enum FilterOptionTypes {
  Papers = 'PrintContent',
  RadioTV = 'AudioVideo',
  Internet = 'internet',
  CPNews = 'cpNews',
  All = 'all',
  Events = 'events',
}
